import { render, staticRenderFns } from "./workFlowModal.vue?vue&type=template&id=af7e78a2&scoped=true"
import script from "./workFlowModal.vue?vue&type=script&lang=js"
export * from "./workFlowModal.vue?vue&type=script&lang=js"
import style0 from "./workFlowModal.vue?vue&type=style&index=0&id=af7e78a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7e78a2",
  null
  
)

export default component.exports